export default {
	SUMMARY: {
		TITLE:
			'The following fields require your attention before you can continue:',
	},

	VALIDATORS: {
		DIRECT_DEBIT: {
			DEBIT_AMOUNT: 'Debit value cannot be greater than maxValueForPlan',
			BSB_NUMBER: 'Please enter a valid BSB.',
		},
		WITHDRAWALS: {
			MINIMUM_BALANCE:
				'To keep your account open, you need to leave at least $1,000 in your account after the withdrawal. Please review your withdrawal amount.',
			MINIMUM_VALUE:
				'The withdrawal amount must be at least $1000. Please enter a higher amount.',
			WITHDRAWAL_AMOUNT_MISMATCH:
				'The amount selected from each investment option must add up to the total amount you want to withdraw.',
			INSUFFICIENT_FUNDS_AVAILABLE: `There's not enough money in this investment option. Select additional option/s to make the withdrawal from.`,
			WHOLE_NUMBER: `Please provide a dollar amount only with no cents or decimal points, for example $450.`,
			REQUIRED_DEBT: 'Please add at least one debt.',
		},
		DEFAULT: {
			REQUIRED: 'Please provide this information',
			EMPTY: 'Please complete this detail.',
			EMPTY_MEMBER_NUMBER: 'Please enter your member number.',
			EMPTY_MEMBER_NUMBER_WITH_HINT:
				'Please enter your member number. It is usually a 10 digit number.',
			EMPTY_FIRST_NAME: 'Please enter your first name.',
			EMPTY_FIRST_NAME_WITH_MIDDLE_NAME:
				'Please enter your given name(s), include any middle names you may have.',
			EMPTY_LAST_NAME: 'Please enter your last name.',
			EMPTY_EMAIL: 'Please enter your email address.',
			MIN_LENGTH:
				'This field is shorter than the minimum number of allowed characters.',
			MAX_LENGTH: 'You have exceeded the maximum number of allowed characters.',
			ABN_MAX_LENGTH: 'The ABN should have 11 numbers with no spaces..........',
			NAME: 'Please enter a valid name.',
			EMAIL:
				"Please enter a valid email address. It should be in the format 'name@email.com' and contain a maximum of 120 characters",
			EMAIL_OR_MOBILE: 'Please enter a valid email address or mobile number.',
			DATE: 'Please enter a valid date.',
			FUTURE_DOB: 'Date of birth cannot be a future date.',
			DATE_BEFORE: 'Please enter a date that is before the to date',
			DATE_AFTER: 'Please enter a date that is after the from date',
			PHONE: 'Please enter a valid phone number.',
			VALID_STRING: 'Please enter valid characters.',
			MEMBER_NUMBER: 'Please enter numeric values only and less than 9 digits.',
			REGISTRATION_MEMBER_NUMBER:
				'Please enter numeric values only and less than 21 digits.',
			BANK_NAME: 'Please enter alphanumeric values only.',
			DISALLOW_EMAIL_FORMAT_PASSWORD:
				"Don't use your email address in your password",
			REQUIRED_PWD_MESSAGE:
				'Please enter a valid password. Your password must be at least 8 characters long and contain at least one upper case letter, one lower case letter and one number.',
			// TODO: Double check if the variable name here is still applicable
			// Ex: 'SAME_VALUE' and 'SAME_VALUE_CONFIRM_PASSWORD' variables contradicts with it's assigned value
			SAME_VALUE: 'The value entered does not match.',
			SAME_VALUE_CONFIRM_PASSWORD: "Your passwords don't match.",
			SAME_EXISTING_VALUE: 'This must match the value you entered earlier.',
			DECIMAL: 'Please enter a valid percentage up to 2 decimal places',
			VALUE: 'Please enter a valid value',
			SPINUSINUMBER: 'Please enter a valid number',
			TFN_FORMAT: 'Please enter a valid TFN.',
			BSB: 'Please enter a valid BSB',
			POSTCODE: 'For an Australian address, type in a 4-digit postcode.',
			INTL_POSTCODE:
				'For international addresses, type in a valid post or zip code.',
			INVALID_ADDRESS:
				'Please enter a valid address. You can type in your address if you need to.',
			INVALID_STREET_ADDRESS:
				'Please enter a valid address which can include the special characters - or /',
			CAPTCHA: 'Please check this to continue.',
			USERNAME: 'Please enter a username between 1 and 120 characters',
			INVALID_USERNAME:
				'The username cannot have double quotes ", forward or backslashes in it.',
			AMOUNT_EXCEEDS_BALANCE:
				'Your entered balance is above the available balance',
			FUND_NOT_SELECTED: 'Please select the account to withdraw from above.',
			SECURITY_CODE: 'Please enter a 6 digit numeric code only',
			LP_SERVICE_ID: 'The service number is invalid',
			SPECIAL_CHARACTERS: `Some special characters aren't allowed in an address. You can only use - or /.`,
			ACCOUNT_NAME: `Please enter your bank account name as first name or initials and surname only. The name must match your AustralianSuper account and cannot contain any special symbols, only letters and numbers. For example John Smith or J D Smith. If it’s a joint account you must be one of the account holders.`,
		},
	},
};
